import {
    Schedule
} from '@vote4dance/judging-schema';
import {
    CompetitionId
} from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type ScheduleItem = Schedule
& {
    schedule_rounds_confirmed: number,
    schedule_rounds_ready: number,
    schedule_rounds_total: number,
}

type ScheduleItemCompanion = {
    hasRounds(schedule: ScheduleItem): boolean;
}

export const ScheduleItem: ScheduleItemCompanion = {
    hasRounds(schedule: ScheduleItem): boolean {
        return ((schedule.schedule_rounds_total == undefined) || (schedule.schedule_rounds_total > 0));
    }
}

export function ScheduleSource(competition_id: CompetitionId) {
    return new StreamSource<ScheduleItem[]>(`/schedule/${competition_id}`);
}